<div class="search-results-dropdown">
  <div class="search-results-container">
    <!-- Results Header -->
    <div class="results-header">
      <div class="flex items-center justify-between">
        <h3 class="text-sm font-semibold text-gray-900">
          <span *ngIf="isSearching">{{ 'Wyszukiwanie…' | translate }}</span>
          <span *ngIf="!isSearching && filteredProducts.length > 0">{{ 'Wyniki wyszukiwania' | translate }}</span>
          <span *ngIf="!isSearching && filteredProducts.length === 0 && !searchError">{{ 'Brak wyników' | translate }}</span>
          <span *ngIf="searchError">{{ 'Błąd wyszukiwania' | translate }}</span>
        </h3>
        <span class="text-xs text-gray-500" *ngIf="!isSearching && !searchError">
          {{ 'Znaleziono produktów:' | translate }} {{ filteredProducts.length }}
        </span>
      </div>
    </div>

    <!-- Results Content -->
    <div class="results-content">
      <!-- Loading State -->
      <div *ngIf="isSearching" class="loading-state">
        <div class="flex items-center justify-center py-8">
          <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div>
          <span class="ml-3 text-sm text-gray-600">{{ 'Wyszukiwanie produktów…' | translate }}</span>
        </div>
      </div>

      <!-- Error State -->
      <div *ngIf="searchError && !isSearching" class="error-state">
        <div class="text-center py-8">
          <div class="text-red-500 mb-2">
            <svg class="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"/>
            </svg>
          </div>
          <h3 class="text-sm font-medium text-gray-900">{{ 'Błąd wyszukiwania' | translate }}</h3>
          <p class="text-xs text-gray-500 mt-1">{{ 'Nie udało się wyszukać produktów. Spróbuj ponownie.' | translate }}</p>
        </div>
      </div>

      <!-- Products Found -->
      <div *ngIf="filteredProducts.length > 0 && !isSearching" class="products-grid">
        <div
          *ngFor="let item of filteredProducts; trackBy: trackByProduct"
          class="product-item"
          [routerLink]="['/products', item?.id]"
          (click)="onProductClick(item)"
        >
          <div class="product-main-content flex gap-4 w-full">
            <!-- Product Image -->
            <div class="product-image-container">
              <img
                [src]="getFirstAvailableImage(item) || '/images/placeholder-product.svg'"
                [alt]="item?.label"
                class="product-image"
                loading="lazy"
              />
              <div class="image-overlay"></div>
            </div>

            <!-- Product Info -->
            <div class="product-info">
              <h4 class="product-title">{{ item?.label }}</h4>
              
              <!-- Category -->
              <div *ngIf="item?.category?.label" class="product-category">
                <svg class="w-3 h-3 text-gray-400 inline mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"/>
                </svg>
                <span class="text-xs text-gray-500">{{ item?.category?.label }}</span>
              </div>
              
              <!-- Price or Request -->
              <div class="product-pricing">
                @if (item?.priceHT && item?.priceHT > 0) {
                  <div class="product-price">
                    <span class="price-amount">{{ item?.priceHT | appendCurrency }}</span>
                  </div>
                } @else {
                  <div class="product-request">
                    <svg class="w-4 h-4 text-orange-500 inline mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                    </svg>
                    <span class="text-xs font-semibold text-orange-600">{{ 'Zapytaj o cenę' | translate }}</span>
                  </div>
                }
              </div>
            </div>
          </div>

          <!-- Technical Data (Variants) - Reduced spacing -->
          <div *ngIf="item?.availableVariants?.length > 0" class="variants-info-block mt-1.5 pt-1.5 border-t border-gray-50">
            <div class="variants-list-vertical">
              <div 
                *ngFor="let variant of item?.availableVariants | slice:0:5" 
                class="variant-row"
              >
                <span class="text-xs font-medium text-gray-900 mr-2">{{ $any(variant)?.variant?.name?.replace(':', '') }}:</span>
                <span class="text-xs text-gray-900 font-medium">
                  @if ($any(variant)?.values?.length === 1) {
                    {{ getCleanValue($any(variant).values[0].value, $any(variant)?.variant?.name) }}
                  } @else {
                    ({{ 'dostępne wartości: ' | translate }}{{ $any(variant)?.values?.length }})
                  }
                </span>
              </div>
              <div *ngIf="item?.availableVariants?.length > 5" class="text-[10px] text-orange-500 mt-1 font-medium">
                +{{ item.availableVariants.length - 5 }} {{ 'kolejnych parametrów' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- No Results State -->
      <div *ngIf="filteredProducts.length === 0 && !isSearching && !searchError" class="no-results-state">
        <div class="no-results-icon">
          <svg class="w-12 h-12 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
          </svg>
        </div>
        <h3 class="no-results-title">{{ 'Nie znaleziono produktów' | translate }}</h3>
        <p class="no-results-description">{{ 'Zmień kryteria wyszukiwania lub przejrzyj kategorie.' | translate }}</p>
        <button class="browse-categories-btn" (click)="onBrowseCategories()">
          {{ 'Przeglądaj kategorie' | translate }}
        </button>
      </div>
    </div>

    <!-- Results Footer -->
    <div *ngIf="filteredProducts.length > 0 && !isSearching" class="results-footer">
      <button class="view-all-btn" (click)="onViewAllResults()">
        {{ 'Zobacz wszystkie wyniki (' | translate }}{{ filteredProducts.length }})
        <svg class="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"/>
        </svg>
      </button>
    </div>
  </div>
</div>
